import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const demoAccounts = [
    { label: 'Superadmin', email: 'superadmin@ortasys.com', password: 'Admin123!' },
    { label: 'Hotel', email: 'hotel@thelayar.com', password: 'Hotel123!' },
    { label: 'Admin Agent', email: 'admin@ptjaya.com', password: 'Agent123!' },
    { label: 'Sub-Agent', email: 'bali@explorer.com', password: 'Agent123!' },
    { label: 'Direct Agent', email: 'lombok@direct.com', password: 'Agent123!' },
    { label: 'Customer', email: 'ahmad@gmail.com', password: 'User123!' },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Email atau password salah');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: '#f8f8f7', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <div style={{ marginBottom: 32, textAlign: 'center' }}>
            <div style={{ fontSize: 32, fontWeight: 700, color: '#0F6E56', marginBottom: 4 }}>Ortasys</div>
            <div style={{ fontSize: 14, color: '#888780' }}>Distribution Control System</div>
          </div>
          <div style={{ background: '#fff', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: 28 }}>
            <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 20 }}>Masuk ke akun kamu</h2>
            {error && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 6, color: '#444441' }}>Email</label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  style={{ width: '100%', padding: '9px 12px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', background: '#fafaf9' }}
                  placeholder="email@example.com"
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 6, color: '#444441' }}>Password</label>
                <input
                  type="password" value={password} onChange={e => setPassword(e.target.value)} required
                  style={{ width: '100%', padding: '9px 12px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', background: '#fafaf9' }}
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '10px', background: '#0F6E56', color: '#fff',
                border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer',
                opacity: loading ? 0.7 : 1,
              }}>{loading ? 'Memproses...' : 'Masuk'}</button>
            </form>
          </div>
          <div style={{ marginTop: 24, background: '#fff', border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, padding: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#888780', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Demo accounts</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              {demoAccounts.map(acc => (
                <button key={acc.email} onClick={() => { setEmail(acc.email); setPassword(acc.password); }}
                  style={{ padding: '7px 10px', border: '0.5px solid rgba(0,0,0,0.12)', borderRadius: 6, background: '#fafaf9', fontSize: 12, cursor: 'pointer', textAlign: 'left' }}>
                  <div style={{ fontWeight: 500 }}>{acc.label}</div>
                  <div style={{ fontSize: 10, color: '#888780', marginTop: 1 }}>{acc.email}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
